(function ($, Promise) {

		var WEST = Math.PI * 1;
		var EAST = Math.PI * 0;

		// Constructor
		function SkillGamesGame3Windsock(parent) {

			this.parent = parent;

			this.tl = false;
			this.counter = 0;

			this.position = {
				x: 0,
				y: 0,
			}

			// Graphic holder
			this.graphic = new PIXI.Container();

			// Pole
			var poleTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/wind-pole.png');
			this.poleSprite = new PIXI.Sprite(poleTexture);
			this.poleSprite.position.set(-11, 0);
			this.graphic.addChild(this.poleSprite);

			// Flag
			var flagTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/wind-flag.png');
			this.flagSprite = new PIXI.Sprite(flagTexture);
			this.flagSprite.position.set(0, 13);
			this.flagSprite.anchor.set(-0.075, 0.15);
			this.graphic.addChild(this.flagSprite);

			// Arrow East
			// var arrowEastTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/wind-arrow-east.png');
			// this.arrowEastSprite = new PIXI.Sprite(arrowEastTexture);
			// this.arrowEastSprite.position.set(185, 15);
			// this.graphic.addChild(this.arrowEastSprite);

			// Arrow East
			// var arrowWestTexture = PIXI.Texture.from('images/skill_games/landing_airplanes/wind-arrow-west.png');
			// this.arrowWestSprite = new PIXI.Sprite(arrowWestTexture);
			// this.arrowWestSprite.position.set(-285, 15);
			// this.graphic.addChild(this.arrowWestSprite);

		}

		SkillGamesGame3Windsock.prototype.setPosition = function (x, y) {
			this.position.x = x;
			this.position.y = y;
			this.graphic.position.x = x;
			this.graphic.position.y = y;
		}

		SkillGamesGame3Windsock.prototype.setDirection = function (direction) {

			// Clear current timeline if any
			if (this.tl != false) {
				this.tl.kill();
				this.tl = false;
			}

			// Animate timeline
			this.tl = new TimelineMax();

			// Animate flag direction
			this.tl.to(this.flagSprite.scale, 0.5, {
				x: (direction == EAST) ? 1 : -1,
				easing: Sine.easeInOut
			}, 0.0);

			// Arrow East
			// this.tl.to(this.arrowEastSprite, 0.5, {
			// 	alpha: (direction == EAST) ? 1 : 0,
			// 	easing: Sine.easeInOut
			// }, 0.0);

			// Arrow West
			// this.tl.to(this.arrowWestSprite, 0.5, {
			// 	alpha: (direction == WEST) ? 1 : 0,
			// 	easing: Sine.easeInOut
			// }, 0.0);
		}


		SkillGamesGame3Windsock.prototype.draw = function (delta) {
			this.counter += delta * 0.1;
			this.flagSprite.rotation = Math.sin(this.counter) * 0.1;
		}

		SkillGamesGame3Windsock.prototype.reset = function () {
			// this.arrowEastSprite.alpha = 0;
			// this.arrowWestSprite.alpha = 0;
		}

		// Expose SkillGamesGame3Windsock
		window.SkillGamesGame3Windsock = SkillGamesGame3Windsock;
	}
)
(jQuery, Promise);
